import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import { AmendBookingData, getAmendData } from 'src/api/amendService';

import { AuthContext } from '../../providers/auth-context';

export const useGetAmendData = (vitaRef: string | null) => {
    const hasVitaRef = vitaRef !== null && vitaRef.length > 0;
    const userState = useContext(AuthContext);

    const query = useQuery<AmendBookingData, AxiosError, AmendBookingData>({
        enabled: userState.loggedIn && hasVitaRef,
        queryKey: ['amend', vitaRef],
        queryFn: async () => getAmendData(vitaRef as string),
    });

    return {
        ...query,
    };
};
